import { HttpErrorResponse } from "@angular/common/http";
import { Component, inject, viewChild, ChangeDetectionStrategy } from "@angular/core";
import { NewDialogComponent } from "common/newdialog/dialog.component";
import { LoadingErrorService } from "files/error/loading-error.service";
import { Subject } from "rxjs";
import { PopupHeaderComponent } from "common/popup/popup-header.component";
import { AsyncPipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { PopupContentComponent } from "common/popup/popup-content.component";
import { FilesLoadingErrorEmbeddableComponent } from "./stages-loading-error-embeddable.component";
import { PopupFooterComponent } from "common/popup/popup-footer.component";

@Component({
	selector: "stages-loading-error",
	templateUrl: "./loading-error.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		NewDialogComponent,
		PopupHeaderComponent,
		TranslateModule,
		PopupContentComponent,
		FilesLoadingErrorEmbeddableComponent,
		PopupFooterComponent,
		AsyncPipe,
	],
})
export class StagesLoadingErrorComponent {
	loadingErrorService = inject(LoadingErrorService);

	readonly dialog = viewChild.required<NewDialogComponent>("dialog");

	loadingError$: Subject<HttpErrorResponse> = new Subject<HttpErrorResponse>();

	constructor() {
		window.setTimeout(() => {
			this.loadingError$.next(this.loadingErrorService.getError());
		}, 1);
	}

	close = (): void => {
		const dialog = this.dialog();
		if (dialog) {
			dialog.close();
		}
	};
}
